import React from 'react';

interface OrderArrivalCardProps {
  content: Array<{
    arrivalDate: string;
    arrivalTime: string;
  }>;
  isCarousel?: boolean;
}

const OrderArrivalCard: React.FC<OrderArrivalCardProps> = ({ content, isCarousel }) => {
  console.log('OrderArrivalCard rendered with content:', content);
  
  if (!content || content.length === 0) {
    console.log('OrderArrivalCard: No content provided');
    return null;
  }

  return (
    <div className="order-arrival-card" style={{ height: isCarousel ? '100%' : 'auto' }}>
      {content.map((item, index) => (
        <div key={index} className="order-arrival-card__item">
          <div className="order-arrival-card__content">
            <div className="order-arrival-card__row order-arrival-card__row--top">
              <span className="order-arrival-card__arrival-text" style={{ fontWeight: 500 }}>
                Arriving {item.arrivalDate} | {item.arrivalTime}
              </span>
            </div>
            <div className="order-arrival-card__row order-arrival-card__row--bottom">
              <span className="order-arrival-card__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 13.75H3.75C3.75 14.4404 4.30964 15 5 15C5.69036 15 6.25 14.4404 6.25 13.75H13.75C13.75 14.4404 14.3096 15 15 15C15.6904 15 16.25 14.4404 16.25 13.75H17.5V10L15 7.5H12.5V5H2.5V13.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="5" cy="13.75" r="1.25" stroke="white" strokeWidth="1.5"/>
      <circle cx="15" cy="13.75" r="1.25" stroke="white" strokeWidth="1.5"/>
    </svg>
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderArrivalCard;
